class ovatBillRuleListCtrl {
    constructor($scope, logger, httpRequest, $location) {
        function qryAllRule () {
            httpRequest.get_qryAllRule().then((res) => {
                $scope.ruleList = res.data.value
                for (const a in $scope.ruleList) {
                    $scope.ruleList[a].validStatus = Number($scope.ruleList[a].validStatus)
                }
            })
        }
        qryAllRule()

        // 添加
        $scope.toAddRule = function toAddRule () {
            if ($scope.ruleList.length >= 10) {
                logger.logError('规则不能超过10条')
            } else {
                $location.path('/system/settingcenter/ovatBillRule/add').replace()
            }
        }
        // 编辑
        $scope.toEditRule = function toEditRule (ruleSchemaCode) {
            $location.path(`/system/settingcenter/ovatBillRule/edit/${ruleSchemaCode}`).replace()
        }
        // 设置规则
        $scope.toSetRule = function toSetRule (ruleSchemaCode) {
            $location.path(`/system/settingcenter/ovatBillRule/set/${ruleSchemaCode}`).replace()
        }
        // 删除规则
        $scope.delRule = function delRule (ruleSchemaId) {
            logger.logMsg({
                title: '提示',
                message: '拆合规则删除后，设置规则无法使用，确认删除？',
                btn: ['确定', '取消'],
                icon: 'tishi',
                yes (index) {
                    httpRequest.get_delRule(ruleSchemaId, '规则删除成功').then((res) => {
                        layer.close(index)
                        qryAllRule()
                    })
                },
            })
        }
        // 启用禁用规则
        $scope.disableSw = false
        $scope.swChange = function swChange (item,validStatus) {
            $scope.disableSw = true
            const msg = validStatus == 1 ? '已启用' : '已禁用'
            httpRequest.get_isEnableRule(item.ruleSchemaId, validStatus).then((res) => {
                $scope.disableSw = false
                logger.logSuccess(msg)
                if(!res.data.success){
                    item.validStatus=validStatus==1?0:1
                    logger.logError(res.data.message)
                }
            }).catch(err => {
                $scope.disableSw = false
                item.validStatus=validStatus==1?0:1
            })
        }
    }
}
ovatBillRuleListCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$location']
export default ovatBillRuleListCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/ovatBillRule/ovatBillRuleListCtrl.js